import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { JuntaDirectivaStep } from "@/components/form-steps/JuntaDirectivaStep";
import { JuntaDirectivaSchema } from "@/schemas/multistep/junta-directiva.schema";

const definition: StepDefinition = {
  id: "juntaDirectiva",
  title: "Junta Directiva",
  schema: JuntaDirectivaSchema,
  Component: JuntaDirectivaStep,
  isApplicable: (tipoDocumento: string = ""): boolean => {
    return tipoDocumento === "NIT";
  },
};

registerStep(definition);
